import React, {useEffect, useRef, useState} from "react";
import {DatePicker, Form,} from "antd";
import {IoCalendarOutline} from "react-icons/io5";
import 'moment/locale/sr';
import locale from 'antd/es/date-picker/locale/sr_RS';

interface DatepickerComponentProps {
  disabledDate?: any;
  bgColor?: string;
  label?: string;
  required?: boolean
  warning?: string
  initialFieldValue?: any
  name?: string
  message?: string

  onChange?(e: any): void
}

const DatePickerComponent = (
  {
    disabledDate,
    initialFieldValue,
    label,
    required,
    message,
    name
  }: DatepickerComponentProps) => {
  const [focus, setFocus] = useState<"focused-datepicker" | undefined>(initialFieldValue ? "focused-datepicker" : undefined);
  const [value, setValue] = useState<any>();
  const inputRef = useRef<any>(null);
  useEffect(() => {
    inputRef.current?.props?.value?._d && setFocus("focused-datepicker");
    inputRef.current.defaultValue && setValue(inputRef.current?.defaultValue);
    console.log(inputRef.current?.props?.value?._d)
  }, [initialFieldValue, inputRef]);
  return (
    <div className={"select"}>
      <div className={`select-label ${focus}`} onClick={() => inputRef.current.focus()}>{label}</div>
      <Form.Item
        style={{width: "100%", display: "flex", justifyContent: "center"}}
        rules={[{required: required, message: message}]}
        name={name}>
        <DatePicker
          inputReadOnly
          value={value}
          defaultValue={!!initialFieldValue ? initialFieldValue : null}
          ref={inputRef}
          locale={locale}
          style={{
            width: "100%",
            borderRadius: "30px",
            padding: "4px 4px 4px 20px",
            backgroundColor: "transparent"
          }}
          onFocus={() => setFocus("focused-datepicker")}
          onBlur={(e) => !e.target.value && setFocus(undefined)}
          disabledDate={disabledDate}
          placeholder={""}
          onChange={(e)=>setValue(e)}
          format={'DD.MM.YYYY'}
          suffixIcon={<div className={"input-tooltip"}
                           style={{backgroundColor: "#4B4B4B", borderRadius: "100%", padding: 5}}>
            <IoCalendarOutline
              style={{color: "#fff", fontSize: "1.5rem"}}/></div>}
        />
      </Form.Item>
    </div>
  )
};

export default DatePickerComponent;
